export default class SpinnerSvc {
    private static spinner: any = null;

    public static set(spinner: any) {
        SpinnerSvc.spinner = spinner;
    }

    public static show(): void {
        SpinnerSvc.spinner.start();
    }

    public static hide(): void {
        setTimeout(() => SpinnerSvc.spinner.complete(), 30);
    }

    public static withSpinner(req: ng.IPromise<any>): ng.IPromise<any> {
        SpinnerSvc.show();

        req.finally(() => SpinnerSvc.hide());
        return req;
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/SpinnerSvc.ts